import React from "react";
import { Message } from "components/generic/layout";
import { UnsignedLayout } from "components/common/auth";

export default () => (
  <UnsignedLayout>
    <Message
      title="Success!"
      text="Your password has been correctly updated! Use it clicking on the Log In link above!"
      showIcon
    />
  </UnsignedLayout>
);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/SetPasswordSuccess/index.js